import { MutationTree } from 'vuex';
import { State } from './database.store';
import DatabaseTypes from '@/utils/databaseTypes';
import * as types from '@/components/Database/database.types';

const mutations: MutationTree<State> = {
  setCurrentDatabaseType(state: State, data: any) {
    state.currentDatabaseType = data;
  },
  setCurrentDatabaseService(state: State, data: any) {
    state.currentDatabaseService = data;
  },
  setDatabaseServices(state: State, data: any) {
    state.databaseServices = data;
  },

  // resets to default values on logout
  setDefaultValues(state: State, data: any) {
    const keylabel = {
      key: '',
      label: '',
      permissions: [],
    };
    state.currentDatabaseType = DatabaseTypes[0];
    state.databaseServices = [];
    state.currentDatabaseService = keylabel;
  },
  [types.databaseMutation.SET_AVG_CPU](state,data) {
    state.avgCpu = data;
  },
  [types.databaseMutation.SET_AVG_MEMORY](state,data) {
    state.avgMemory = data;
  }
};
 

export default mutations;
